const initialState = {
  byWidgetId: {}
};

const tefilotReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_TEFILOT_START':
      return {
        ...state,
        byWidgetId: {
          ...state.byWidgetId,
          [action.payload.widgetId]: {
            ...state.byWidgetId[action.payload.widgetId],
            loading: true,
            error: null
          }
        }
      };

    case 'FETCH_TEFILOT_SUCCESS':
      return {
        ...state,
        byWidgetId: {
          ...state.byWidgetId,
          [action.payload.widgetId]: {
            loading: false,
            error: null,
            data: action.payload.data
          }
        }
      };

    case 'FETCH_TEFILOT_FAILURE':
      return {
        ...state,
        byWidgetId: {
          ...state.byWidgetId,
          [action.payload.widgetId]: {
            ...state.byWidgetId[action.payload.widgetId],
            loading: false,
            error: action.payload.error
          }
        }
      };

    default:
      return state;
  }
};

export default tefilotReducer;
